<template>
  <div>
    <riseup-header/>
    <loader v-if="isLoading"/>
    <div v-else class="discount-incomplete">
      <div class="content">
        <div>
          <img class="wait-icon" :src="require('@/assets/onboarding/icons/big-icon-discount-incomplete.svg')">
          <div class="title">לא סיימת לחבר את חשבון דיסקונט אבל אין בעיה, אפשר גם כאן</div>
          <div class="help-section">
            <div class="text">שכחת את פרטי ההתחברות לאתר דיסקונט?
              <div class="link" v-on:click="openForgotPasswordLink">אפשר לשחזר אותם כאן</div>
            </div>
          </div>
          <div class="button-container">
            <single-click-button :title="'לחיבור עם שם משתמש וסיסמה'" :size="'small'"
                           :action="deleteAndTryAgainWithDiscountDirect" :disabled="loading"/>
            <single-click-button :variant="'secondary'" :title="'לנסות שוב באתר דיסקונט'" :size="'small'"
                           :action="deleteAndsSwitchToUserNamePassword" :disabled="loading"/>
          </div>
          <base-tool-tip :icon-path="'icon-info.svg'" class="tool-tip-wrapper">
            <div class="tool-tip-text bold">התחלת לחבר חשבון בנק משותף?</div>
            <div class="tool-tip-text">אחרי החתימה על הטפסים והקמת ההרשאה בבנק, תגיע אליך הודעת sms להשלמת החיבור.</div>
          </base-tool-tip>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapActions, mapState } from 'vuex';
import BaseToolTip from '@/base-components/onboarding/BaseToolTip';
import SingleClickButton from '../../../../base-components/SingleClickButton';
import Segment from '../../../../Segment';
import Loader from '../../../../base-components/Loader.vue';
import RiseupHeader from '../../../../base-components/app-header/RiseupHeader.vue';

export default {
  name: 'DiscountIncomplete',
  components: {
    SingleClickButton,
    Loader,
    RiseupHeader,
    BaseToolTip,
  },
  async created() {
    Segment.trackUserGot('DiscountIncompleteShown', { query: this.$route.query });
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapState('onboardingState', ['isLoading']),
  },
  methods: {
    ...mapMutations('onboardingState', ['setPageName', 'setPageParams']),
    ...mapActions('onboardingState', ['discountIncompleteBack']),
    async deleteAndTryAgainWithDiscountDirect() {
      this.loading = true;
      Segment.trackUserInteraction('TryDiscountApiAgain');
      await this.discountIncompleteBack();
      await this.setPageParams({ sourceName: 'דיסקונט ישיר' });
      this.loading = false;
    },
    async deleteAndsSwitchToUserNamePassword() {
      this.loading = true;
      Segment.trackUserInteraction('SwitchToDiscountUserNamePassword');
      Segment.trackUserInteraction('DiscountIncompleteShown');
      await this.discountIncompleteBack();
      await this.setPageParams({ sourceName: 'דיסקונט ישיר' });
      this.loading = false;
    },
    openForgotPasswordLink() {
      window.open('https://www.discountbank.co.il/DB/private/online-banking/identification-code?tab=1', '_blank');
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../../scss/mixins';

  .discount-incomplete {
    @include white-page-frame;
    @include responsive-padding;
    height: 100%;
    text-align: center;

    .content {
      height: 100%;
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .wait-icon {
        margin: 60px 0 30px;
      }

      .title {
        font-size: 20px;
        font-weight: bold;
        color: $riseup_black;
        margin-bottom: 15px;
        line-height: 1.3;
      }

      .help-section {
        margin-bottom: 40px;

        .text {
          font-size: 16px;
          line-height: 1.38;
          white-space: pre-line;
          color: $riseup_black;
          margin-bottom: 30px;

          .link {
            text-decoration: underline;
            color: $riseup_blue;
            cursor: pointer;
            font-weight: bold;
          }
        }
      }

      .button-container {
        width: 100%;

        .riseup-button {
          width: 100%;
          margin-bottom: 15px;
          &:last-of-type {
            margin-bottom: 30px;
          }
        }
      }

      .tool-tip-wrapper {
        margin-bottom: 30px;

        .tool-tip-text {
          font-size: 14px;
          font-family: SimplerPro;
          text-align: right;
          line-height: 1.36;

          &.bold {
            font-weight: bold;
            margin-bottom: 5px;
          }
        }
      }
    }
  }
</style>
